import { AccountResponse } from "@/features/cash-pooling/types";
import { Avatar, Button, Stack, Typography } from "@datanomik/commons-ui";
import { CloseLine } from "@datanomik/commons-ui/icons";
import { formatCnpj } from "@/features/bank-integrations/utils/cnpj.utils";

type SelectedAccountInputProps = {
  account: AccountResponse;
  onEdit?: () => void;
};

export const SelectedAccountInput = ({ account, onEdit }: SelectedAccountInputProps) => {
  return (
    <Stack sx={{
      border: '1px solid',
      borderColor: 'divider',
      px: 1,
      py: '4px',
      bgcolor: 'background.paper',
      width: '100%',
      '&:not(:first-child)': {
        borderTop: 'none',
      },
      '&:first-child': {
        borderTopLeftRadius: '16px',
        borderTopRightRadius: '16px',
      },
      '&:last-child': {
        borderBottomLeftRadius: '16px',
        borderBottomRightRadius: '16px',
      },
    }}>
      <Stack direction="row" alignItems="center" spacing={1}>
        <Stack justifyContent="start">
          <Avatar
            src={account.institution.logo}
            alt={account.institution.name}
            sx={{
              width: 20,
              height: 20,
              border: '1px solid',
              borderColor: 'divider',
              bgcolor: 'transparent',
            }}
            imgProps={{
              sx: { objectFit: 'contain' },
            }}
          />
        </Stack>
        <Stack sx={{ flex: 1, minWidth: 0 }}>
          <Stack direction="row" alignItems="center" spacing={1} sx={{ minWidth: 0 }}>
            <Typography fontWeight={500} noWrap fontSize="11px" sx={{ minWidth: 0 }}>
              {account.owner.fiscalName}
            </Typography>
            <Typography
              color="text.secondary"
              noWrap
              sx={{
                fontFamily: 'monospace',
                fontWeight: 500,
                fontSize: '10px',
                flexShrink: 0,
              }}
            >
              {formatCnpj(account.owner.fiscalNumber)}
            </Typography>
          </Stack>
          <Typography color="text.secondary" noWrap fontSize="10px">
            Agência: {account.account.branch} • Conta: {account.account.accountNumber}
          </Typography>
        </Stack>
        <Stack justifyContent="center">
          <Button
            startIcon={<CloseLine />}
            size="small"
            variant="text"
            color="black"
            onClick={onEdit}
          />
        </Stack>
      </Stack>
    </Stack>
  );
};
